import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { compareDesc } from 'date-fns';
import { useMemo } from 'react';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { PromotionalEvent } from './PromotionalEvent/index.tsx';
import type { PromotionalEvents_PromotionalEvent } from './__generated__/index.graphql.ts';

type Props = {
  promotionalEvents: PromotionalEvents_PromotionalEvent[];
};

export const PromotionalEvents = ({ promotionalEvents }: Props) => {
  const promotionalEventsWithBanner = useMemo(
    () =>
      promotionalEvents
        .filter(p => p.pictureUrl)
        .sort((a, b) => compareDesc(a.startDate, b.startDate)),
    [promotionalEvents]
  );
  if (promotionalEventsWithBanner.length === 0) {
    return null;
  }

  return (
    <FullWidthContainer.NoPadding>
      <Vertical gap={0}>
        {promotionalEventsWithBanner.map(p => (
          <PromotionalEvent key={p.slug} promotionalEvent={p} />
        ))}
      </Vertical>
    </FullWidthContainer.NoPadding>
  );
};

PromotionalEvents.fragments = {
  PromotionalEvent: gql`
    fragment PromotionalEvents_PromotionalEvent on PromotionalEventInterface {
      slug
      pictureUrl
      startDate
      ...PromotionalEvent_PromotionalEvent
    }
    ${PromotionalEvent.fragments.PromotionalEvent}
  ` as TypedDocumentNode<PromotionalEvents_PromotionalEvent>,
};
